import Vue from 'vue'
import Vuex from 'vuex'
import ls from './LStorage'
Vue.use(Vuex)
export default new Vuex.Store({
    state:{
        userId:null,
        type:null,//1-普通用户，2-销售，3-医生
        userInfo:{},
        faceId:null,//上传的脸部id
        tongueId:null,//上传的舌头id
        answer:null,//问诊答案
        faceFile:null,//面诊图片
        tongueFile:null,//舌诊图片
        newUser:{},//当前测试者的信息
        isWeChat: false,
        isWeChatQr: false,
        ext:null
    },
    mutations: {
        //修改userId
        setUserId(state, id) {
            state.userId = id;
            ls.setItem('userId', id);
        },
        //修改type
        setType(state, val) {
            state.type = val;
            ls.setItem('type', val);
        },
        //修改脸部id
        setFaceId(state, id) {
            state.faceId = id;
            ls.setItem('faceId', id);
        },
        //修改舌头id
        setTongueId(state, id) {
            state.tongueId = id;
            ls.setItem('tongueId', id);
        },
         setExt(state,ext) {
            state.ext=ext;
            ls.setItem('ext',ext);
         },
        //修改问诊答案
        setAnswer(state, answer) {
            state.answer = answer;
            ls.setItem('answer', answer);
        },
        setIsWeChat(state, value) {
            state.isWeChat = value;
        },
        //修改面诊图片
        setFaceFile(state, file) {
            state.faceFile = file;
        },
        //修改舌诊图片
        setTongueFile(state, file) {
            state.tongueFile = file;
        },
        //修改当前测试者的信息
        setnewUser(state, info) {
            state.newUser = info;
            ls.setItem('newUser', info);
        },
        setIsWeChatQr(state, value) {
            state.isWeChatQr = value;
        },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js